module.exports = __webpack_public_path__ + "static/media/PaymentOnboardingSuccess.9f1977f0.svg";